export function openShare(state, _presence) {
  if (!state.title || !state.title.trim()) {
    alert("Add a title before sharing.");
    return;
  }
  const dialog = document.createElement("div");
  dialog.className = "share-overlay open";
  dialog.innerHTML = `
    <div class="share-dialog">
      <h2 class="share-title">Share to createdtime</h2>
      <p class="share-lede">Sharing posts a snapshot. Your local composition is untouched.</p>
      <label class="share-label">Attach a name (optional)
        <input class="share-input" id="share-author" maxlength="40" placeholder="anonymous">
      </label>
      <div id="share-msg" class="share-msg"></div>
      <div class="share-actions">
        <button class="editor-btn" id="share-cancel">Cancel</button>
        <button class="editor-btn primary" id="share-submit">Share</button>
      </div>
    </div>
  `;
  document.body.appendChild(dialog);
  const inputEl = dialog.querySelector("#share-author");
  const msgEl = dialog.querySelector("#share-msg");
  const cancel = dialog.querySelector("#share-cancel");
  const submit = dialog.querySelector("#share-submit");

  function close() { dialog.remove(); }
  cancel.addEventListener("click", close);

  submit.addEventListener("click", async () => {
    submit.disabled = true;
    msgEl.textContent = "";
    const author = inputEl.value.trim() || null;
    const payload = {
      title: state.title.trim(),
      description: state.description || "",
      author,
      cards: state.cards.map(({ suit, index, x, y }) => ({ suit, index, x, y })),
    };
    try {
      const res = await fetch("/api/createdtime", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(payload),
      });
      const body = await res.json();
      if (res.ok && body.ok) {
        dialog.querySelector(".share-dialog").innerHTML = `
          <h2 class="share-title">Shared</h2>
          <p class="share-lede">Your time is in createdtime.</p>
          <div class="share-actions">
            <a href="/createdtime" class="editor-btn primary">View createdtime →</a>
            <button class="editor-btn" id="share-done">Close</button>
          </div>
        `;
        dialog.querySelector("#share-done").addEventListener("click", close);
      } else {
        msgEl.textContent = body.error === "rate_limited"
          ? "You've shared a few too quickly. Try again in a bit."
          : "Couldn't share: " + (body.error || "unknown error");
        submit.disabled = false;
      }
    } catch {
      msgEl.textContent = "Network error. Try again.";
      submit.disabled = false;
    }
  });
}
